module.exports = __webpack_public_path__ + "static/media/InterviewModeSelfQuestion.b141e5e7.svg";